import {computed, Ref} from "vue";
import {SelectableObject, TextObject} from "@k/js/selectableObjects";

import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {CONTROLLER_EVENTNAMES, SELOBEVENTNAMES} from "@k/global/GlobalEventnames";
import {ColorUtilsVue} from "@km/js/ColorUtilsVue";
import {TabNames} from "@km/data/tabs";
import {TEXTMODULE_POSSIBLE_STATES} from "@km/components/text/ModuleTextAnimations";
import {SelObTypes} from "@k/js/SelObTypes";
import {Store} from "vuex";
import {useModuleTextOpenStatusStore} from "@km/store/frontendstate/useModuleTextOpenState";

export class ModuleTextFunctions {
    private textObjectToEdit: Ref<TextObject | null>;
    private store;

    constructor(store, textObjectToEdit: Ref<TextObject | null>) {
        this.textObjectToEdit = textObjectToEdit;
        this.store = store;
    }

    selObSelectedEventHandler(data: SelectableObject, store) {
        this.setTextObjectToEditFromParameter(data);
        const openStatusStore = useModuleTextOpenStatusStore();
        if (this.textObjectToEdit.value !== null) {
            if(!store.getters.TEXTTABisOpen) {
                store.commit("SET_TAB_OPEN", TabNames.TEXT);
            }
            openStatusStore.setCurrentState(TEXTMODULE_POSSIBLE_STATES.edit);
        } else {
            this.setTextLayersToTextverwaltung();
        }
    }

    private setTextLayersToTextverwaltung() {
        useModuleTextOpenStatusStore().setCurrentState(TEXTMODULE_POSSIBLE_STATES.textverwaltung);
    }

    setTextObjectToEditFromParameter(data: SelectableObject) {
        this.textObjectToEdit.value = null;
        this.textObjectToEdit.value = data?.type === SelObTypes.TEXT ? data as TextObject : null;
    }

    selObDeSelectedEventHandler(tabIsOpen:boolean) {
        this.textObjectToEdit.value = null;
        if(tabIsOpen) {
            this.setTextLayersToTextverwaltung();
        } else {
            useModuleTextOpenStatusStore().setCurrentState(TEXTMODULE_POSSIBLE_STATES.closed);
        }
    }

    deleteTextElem(idToRemove) {
        EventVerteiler.broadcast(SELOBEVENTNAMES.DELETEREQUEST, idToRemove);
    }

    setFontColor(colorObj) {
        EventVerteiler.broadcast(CONTROLLER_EVENTNAMES.CHANGESELOBWITHHISTORY, {
            id: (this.textObjectToEdit.value as TextObject).id,
            changedProperties: {colorValue: ColorUtilsVue.intValueFromHex(colorObj.RGBHex)}
        })
    }

    setOutlineColor(colorObj) {
        EventVerteiler.broadcast(CONTROLLER_EVENTNAMES.CHANGESELOBWITHHISTORY, {
            id: (this.textObjectToEdit.value as TextObject).id,
            changedProperties: {outlineColorValue: ColorUtilsVue.intValueFromHex(colorObj.RGBHex)}
        })
    }

    setColorNone() {
        EventVerteiler.broadcast(CONTROLLER_EVENTNAMES.CHANGESELOBWITHHISTORY, {
            id: (this.textObjectToEdit.value as TextObject).id,
            changedProperties: {outlineColorValue: "<none>"}
        })
    }

    getTextObjectById(id) {
        return this.store.getters.getTextObjectById(id)
    }

    setEventListeners(eventListener: EventListener, store) {
        eventListener.addEventListener(
            [SELOBEVENTNAMES.SELECTION_CLEARED, SELOBEVENTNAMES.DELETED, "colorSelectedEvent"],
            () => this.selObDeSelectedEventHandler(store.getters.TEXTTABisOpen)
        );
        eventListener.addEventListener(SELOBEVENTNAMES.SELECTED, (data) => this.selObSelectedEventHandler(data, store));
        eventListener.addEventListener("selObSelectedFromRahmen", id => this.selObSelectedEventHandler(this.getTextObjectById(id), store))
        eventListener.addEventListener(SELOBEVENTNAMES.CHANGED, ({selOb}) => this.setTextObjectToEditFromParameter(selOb))
    }

    getComputedValues(textObjectToEdit: Ref<TextObject | null>, store:Store<any>) {
        const currentPalettenCluster = computed(() => store.getters.getPalettenCluster("CM5 Bedruckbar"));
        return {
            currentPalettenCluster,
            currentPalettenClusterSorted:computed(()=>store.getters.getPalettenClusterSorted(currentPalettenCluster.value)),
            getColorValue: computed(() => textObjectToEdit.value === null ? null : textObjectToEdit.value.colorValue),
            getOutlineColorValue: computed(() => textObjectToEdit.value === null ? null : textObjectToEdit.value.outlineColorValue),
            textObjects: computed(() => store.getters.getTextObjects)
        }
    }

    public deselectIfSelected() {
        if(this.textObjectToEdit.value !== null) {
            EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_CLEARED)
        }
    }
}
